<template>
    <div>
        <el-tabs v-model="query.search_status" @tab-click="handleSearch">
            <el-tab-pane label="上架" name="1"></el-tab-pane>
            <el-tab-pane label="下架" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="请输入标题进行搜索" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('nrgl_story_xz')">
                <el-button size="mini" type="primary" @click="handleAdd"> 新增 </el-button>
            </template>
            <template slot="columns">
                <el-table-column label="序号" align="center" type="index" width="100" />
                <el-table-column label="标题" align="center" prop="name" />
                <el-table-column label="创建时间" align="center" prop="create_time" />
                <el-table-column
                    v-if="
                        permission('nrgl_story_bj') || permission(row.status == 1 ? 'nrgl_story_xj' : 'nrgl_story_sj') || permission('nrgl_story_sc')
                    "
                    label="操作"
                    align="center"
                    width="200"
                >
                    <template slot-scope="{ row }">
                        <el-button v-if="permission('nrgl_story_bj')" size="mini" type="text" @click="handleEdit(row)"> 编辑 </el-button>
                        <el-button
                            v-if="permission(row.status == 1 ? 'nrgl_story_xj' : 'nrgl_story_sj')"
                            size="mini"
                            type="text"
                            @click="handleUpdate(row)"
                        >
                            {{ row.status == 1 ? "下架" : "上架" }}
                        </el-button>
                        <el-button v-if="permission('nrgl_story_sc')" size="mini" type="text" @click="handleDel(row)"> 删除 </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
    </div>
</template>

<script>
import { list, del, edit } from "@/api/content/story";
import listMixin from "@/mixins/list";

export default {
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                search_status: "1",
            },
            module: "故事",
            formPath: "/content/story/form",
            uuidKey: "cuuid",
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            this._search();
        },
        handleUpdate(row) {
            edit({ ...row, status: row.status == 1 ? 2 : 1 }).then(({ code, error }) => {
                if (code === 200) {
                    this.$message.success(row.status == 1 ? "下架成功" : "上架成功");
                    this.search();
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>
